// extracted by mini-css-extract-plugin
export default {"menuLink":"menuLink__KGPJ4","menuLink_active":"menuLink_active__FY5GH"};